module.exports = __webpack_public_path__ + "static/media/U27b2SqZNH4.e19deb56.jpg";